export default {
    pinganActivityUserPrizeList:
        "/gateway/huilianOperation/hoPinganActivitycs/pinganActivityUserPrizeList?activity=365", //365活动中奖记录
    finishShareTask:
        "/gateway/huilianOperation/hoPinganActivitycs/finishShareTask?activity=365", // 完成分享任务
    selectHoActivityManagementSimpleDetail:
        "/gateway/huilianOperation/hoActivityManagementcs/selectHoActivityManagementSimpleDetail?activity=365", // 活动简要查看
};



// WEBPACK FOOTER //
// ./src/peaceSharkIndex/record/api.js